export default __webpack_public_path__ + "static/media/onpath_title.png";